var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 68,
    viewBox: "0 0 184 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.847107,
    width: 182.444,
    height: 67.9996,
    rx: 10.2641,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_619_14495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0579 17.2185C18.6636 17.6374 18.4306 18.2875 18.4306 19.1293V49.2069C18.4306 50.0501 18.6636 50.6988 19.0579 51.1177L19.1581 51.2156L35.9416 34.3667V34.1681V33.9696L19.1581 17.1193L19.0579 17.2185Z",
    fill: "url(#paint0_linear_619_14495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5347 39.9842L35.9411 34.3661V34.1675V33.9689L41.536 28.3522L41.662 28.4243L48.2906 32.205C50.1831 33.2849 50.1831 35.0515 48.2906 36.1327L41.662 39.9135L41.5347 39.9842Z",
    fill: "url(#paint1_linear_619_14495)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_619_14495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.6614 39.9128L35.9391 34.1682L19.0568 51.1178C19.6799 51.7815 20.7109 51.8631 21.8718 51.2021L41.6614 39.9128Z",
    fill: "url(#paint2_linear_619_14495)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6614 28.4237L21.8718 17.1358C20.7109 16.4735 19.6799 16.5564 19.0568 17.2201L35.9405 34.1697L41.6614 28.4237Z",
    fill: "url(#paint3_linear_619_14495)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2758 35.8138C89.2664 35.8138 86.8137 38.1016 86.8137 41.2527C86.8137 44.3845 89.2664 46.6915 92.2758 46.6915C95.2864 46.6915 97.7391 44.3845 97.7391 41.2527C97.7378 38.1016 95.2851 35.8138 92.2758 35.8138ZM92.2758 44.5508C90.6265 44.5508 89.205 43.1914 89.205 41.254C89.205 39.2961 90.6278 37.9571 92.2758 37.9571C93.925 37.9571 95.3465 39.2961 95.3465 41.254C95.3465 43.1901 93.925 44.5508 92.2758 44.5508ZM80.3587 35.8138C77.3494 35.8138 74.8967 38.1016 74.8967 41.2527C74.8967 44.3845 77.3494 46.6915 80.3587 46.6915C83.3693 46.6915 85.8221 44.3845 85.8221 41.2527C85.8221 38.1016 83.3693 35.8138 80.3587 35.8138ZM80.3587 44.5508C78.7095 44.5508 77.288 43.1914 77.288 41.254C77.288 39.2961 78.7108 37.9571 80.3587 37.9571C82.008 37.9571 83.4295 39.2961 83.4295 41.254C83.4308 43.1901 82.008 44.5508 80.3587 44.5508ZM66.1847 37.484V39.791H71.7095C71.5444 41.089 71.112 42.0366 70.4518 42.6952C69.6483 43.4983 68.3905 44.3845 66.1847 44.3845C62.7839 44.3845 60.1251 41.644 60.1251 38.2449C60.1251 34.8457 62.7839 32.1052 66.1847 32.1052C68.0195 32.1052 69.3591 32.8265 70.3481 33.7536L71.9769 32.1257C70.5951 30.8072 68.7616 29.7982 66.1847 29.7982C61.5262 29.7982 57.6097 33.5887 57.6097 38.2449C57.6097 42.9011 61.5262 46.6915 66.1847 46.6915C68.6989 46.6915 70.5963 45.8667 72.0793 44.3219C73.6044 42.7975 74.0791 40.6542 74.0791 38.9239C74.0791 38.3894 74.0381 37.8945 73.955 37.4827L66.1847 37.484ZM124.155 39.2756C123.702 38.0607 122.32 35.8138 119.497 35.8138C116.693 35.8138 114.363 38.0185 114.363 41.2527C114.363 44.3014 116.673 46.6915 119.764 46.6915C122.258 46.6915 123.701 45.1672 124.3 44.2809L122.444 43.0443C121.826 43.951 120.981 44.5482 119.764 44.5482C118.548 44.5482 117.682 43.9919 117.126 42.8998L124.402 39.892L124.155 39.2756ZM116.734 41.089C116.673 38.9866 118.363 37.9162 119.58 37.9162C120.528 37.9162 121.331 38.3907 121.6 39.0697L116.734 41.089ZM110.819 46.3629H113.209V30.3762H110.819V46.3629ZM106.901 37.03H106.82C106.283 36.3906 105.252 35.8138 103.955 35.8138C101.233 35.8138 98.7397 38.2039 98.7397 41.2744C98.7397 44.3231 101.233 46.6928 103.955 46.6928C105.253 46.6928 106.283 46.116 106.82 45.4575H106.901V46.2401C106.901 48.3207 105.788 49.4333 103.996 49.4333C102.532 49.4333 101.625 48.3834 101.254 47.4972L99.1721 48.3629C99.7696 49.8042 101.356 51.5766 103.996 51.5766C106.799 51.5766 109.17 49.9282 109.17 45.9102V36.145H106.903L106.901 37.03ZM104.161 44.5508C102.512 44.5508 101.131 43.1696 101.131 41.2744C101.131 39.3574 102.512 37.9571 104.161 37.9571C105.788 37.9571 107.066 39.3574 107.066 41.2744C107.066 43.1696 105.788 44.5508 104.161 44.5508ZM135.356 30.3762H129.635V46.3629H132.021V40.3063H135.354C138 40.3063 140.603 38.3919 140.603 35.3419C140.603 32.2919 138.002 30.3762 135.356 30.3762ZM135.417 38.0812H132.021V32.6014H135.417C137.202 32.6014 138.215 34.0785 138.215 35.3419C138.215 36.5798 137.202 38.0812 135.417 38.0812ZM150.172 35.7857C148.443 35.7857 146.653 36.5466 145.913 38.2334L148.031 39.117C148.484 38.2334 149.329 37.9443 150.213 37.9443C151.448 37.9443 152.703 38.6848 152.723 40.0007V40.1657C152.291 39.9189 151.364 39.5493 150.233 39.5493C147.95 39.5493 145.623 40.8038 145.623 43.1479C145.623 45.2874 147.497 46.6647 149.595 46.6647C151.199 46.6647 152.085 45.9447 152.64 45.1007H152.722V46.3347H155.028V40.2053C155.029 37.3689 152.908 35.7857 150.172 35.7857ZM149.883 44.5469C149.102 44.5469 148.011 44.1556 148.011 43.1888C148.011 41.9547 149.37 41.4816 150.543 41.4816C151.591 41.4816 152.086 41.7079 152.723 42.0161C152.538 43.4983 151.262 44.5469 149.883 44.5469ZM163.423 36.1348L160.687 43.066H160.605L157.764 36.1348H155.193L159.452 45.8219L157.024 51.2109H159.513L166.078 36.1348H163.423ZM141.921 46.3629H144.307V30.3762H141.921V46.3629Z",
    fill: "#090909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8877 20.9203C65.8877 21.9725 65.5707 22.81 64.9354 23.4353C64.2144 24.1787 63.2736 24.5504 62.1179 24.5504C61.0109 24.5504 60.0688 24.1737 59.2954 23.4203C58.5207 22.6656 58.1334 21.7314 58.1334 20.6164C58.1334 19.5001 58.5207 18.5659 59.2954 17.8125C60.0688 17.0579 61.0109 16.6812 62.1179 16.6812C62.6676 16.6812 63.193 16.7866 63.6916 16.9963C64.1914 17.2073 64.5915 17.4873 64.8906 17.8376L64.217 18.5006C63.7095 17.9042 63.0102 17.6066 62.1167 17.6066C61.3088 17.6066 60.6108 17.8853 60.0215 18.4429C59.4322 19.0004 59.1382 19.7249 59.1382 20.6151C59.1382 21.5054 59.4322 22.2299 60.0215 22.7874C60.6108 23.3449 61.3088 23.6237 62.1167 23.6237C62.9731 23.6237 63.6877 23.3437 64.2591 22.7824C64.6299 22.417 64.8446 21.9085 64.9021 21.2568H62.1167V20.3515H65.8328C65.8711 20.5486 65.8877 20.7382 65.8877 20.9203Z",
    fill: "#090909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.781 17.7737H68.2886V20.1619H71.4384V21.0672H68.2886V23.4555H71.781V24.3822H67.303V16.8482H71.781V17.7737Z",
    fill: "#090909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9367 24.3822H74.9511V17.7737H72.8086V16.8482H78.0791V17.7737H75.9367V24.3822Z",
    fill: "#090909"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8923 24.3822V16.8482H82.8779V24.3822H81.8923Z",
    fill: "#090909"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2487 24.3822H86.2631V17.7737H84.1207V16.8482H89.3912V17.7737H87.2487V24.3822Z",
    fill: "#090909"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3683 23.409C98.6141 24.17 97.6771 24.5504 96.556 24.5504C95.4349 24.5504 94.4979 24.17 93.7449 23.409C92.9907 22.6481 92.6149 21.7164 92.6149 20.6152C92.6149 19.514 92.9907 18.5823 93.7449 17.8214C94.4979 17.0604 95.4349 16.6787 96.556 16.6787C97.6707 16.6787 98.6064 17.0617 99.3632 17.8264C100.12 18.5911 100.498 19.5203 100.498 20.6152C100.498 21.7164 100.121 22.6481 99.3683 23.409ZM94.4723 22.7774C95.0399 23.3425 95.734 23.6238 96.556 23.6238C97.3779 23.6238 98.0733 23.3412 98.6396 22.7774C99.2072 22.2124 99.4923 21.4916 99.4923 20.6152C99.4923 19.7387 99.2072 19.018 98.6396 18.453C98.0733 17.8879 97.3779 17.6066 96.556 17.6066C95.734 17.6066 95.0399 17.8892 94.4723 18.453C93.906 19.018 93.6209 19.7387 93.6209 20.6152C93.6209 21.4916 93.906 22.2124 94.4723 22.7774Z",
    fill: "#090909"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.882 24.3822V16.8482H103.081L106.808 22.7084H106.85L106.808 21.2569V16.8482H107.794V24.3822H106.765L102.865 18.237H102.822L102.865 19.6885V24.3822H101.882Z",
    fill: "#090909"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8877 20.9203C65.8877 21.9725 65.5707 22.81 64.9354 23.4353C64.2144 24.1787 63.2736 24.5504 62.1179 24.5504C61.0109 24.5504 60.0688 24.1737 59.2954 23.4203C58.5207 22.6656 58.1334 21.7314 58.1334 20.6164C58.1334 19.5001 58.5207 18.5659 59.2954 17.8125C60.0688 17.0579 61.0109 16.6812 62.1179 16.6812C62.6676 16.6812 63.193 16.7866 63.6916 16.9963C64.1914 17.2073 64.5915 17.4873 64.8906 17.8376L64.217 18.5006C63.7095 17.9042 63.0102 17.6066 62.1167 17.6066C61.3088 17.6066 60.6108 17.8853 60.0215 18.4429C59.4322 19.0004 59.1382 19.7249 59.1382 20.6151C59.1382 21.5054 59.4322 22.2299 60.0215 22.7874C60.6108 23.3449 61.3088 23.6237 62.1167 23.6237C62.9731 23.6237 63.6877 23.3437 64.2591 22.7824C64.6299 22.417 64.8446 21.9085 64.9021 21.2568H62.1167V20.3515H65.8328C65.8711 20.5486 65.8877 20.7382 65.8877 20.9203Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.781 17.7737H68.2886V20.1619H71.4384V21.0672H68.2886V23.4555H71.781V24.3822H67.303V16.8482H71.781V17.7737Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9367 24.3822H74.9511V17.7737H72.8086V16.8482H78.0791V17.7737H75.9367V24.3822Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8923 24.3822V16.8482H82.8779V24.3822H81.8923Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2487 24.3822H86.2631V17.7737H84.1207V16.8482H89.3912V17.7737H87.2487V24.3822Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3683 23.409C98.6141 24.17 97.6771 24.5504 96.556 24.5504C95.4349 24.5504 94.4979 24.17 93.7449 23.409C92.9907 22.6481 92.6149 21.7164 92.6149 20.6152C92.6149 19.514 92.9907 18.5823 93.7449 17.8214C94.4979 17.0604 95.4349 16.6787 96.556 16.6787C97.6707 16.6787 98.6064 17.0617 99.3632 17.8264C100.12 18.5911 100.498 19.5203 100.498 20.6152C100.498 21.7164 100.121 22.6481 99.3683 23.409ZM94.4723 22.7774C95.0399 23.3425 95.734 23.6238 96.556 23.6238C97.3779 23.6238 98.0733 23.3412 98.6396 22.7774C99.2072 22.2124 99.4923 21.4916 99.4923 20.6152C99.4923 19.7387 99.2072 19.018 98.6396 18.453C98.0733 17.8879 97.3779 17.6066 96.556 17.6066C95.734 17.6066 95.0399 17.8892 94.4723 18.453C93.906 19.018 93.6209 19.7387 93.6209 20.6152C93.6209 21.4916 93.906 22.2124 94.4723 22.7774Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.882 24.3822V16.8482H103.081L106.808 22.7084H106.85L106.808 21.2569V16.8482H107.794V24.3822H106.765L102.865 18.237H102.822L102.865 19.6885V24.3822H101.882Z",
    stroke: "white",
    strokeWidth: 0.0524781,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_619_14495",
    x: 18.4306,
    y: 16.6787,
    width: 31.2794,
    height: 34.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.203999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_619_14495"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.203999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_619_14495",
    result: "effect2_innerShadow_619_14495"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_619_14495",
    x: 19.0568,
    y: 34.1682,
    width: 22.6046,
    height: 17.4905,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.203999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_619_14495"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_14495",
    x1: 34.4538,
    y1: 18.8111,
    x2: 11.6306,
    y2: 41.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_619_14495",
    x1: 50.7541,
    y1: 34.1675,
    x2: 17.9758,
    y2: 34.1675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_619_14495",
    x1: 38.5538,
    y1: 37.2879,
    x2: 7.60266,
    y2: 68.1187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_619_14495",
    x1: 14.8049,
    y1: 7.20755,
    x2: 28.6254,
    y2: 20.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google_Play.2cd0885f1b7306b91ed124c0c2d26c3d.svg";
export { ForwardRef as ReactComponent };